export default class TimeCalc {

  static MODE_NONE = 0

  static MODE_1000 = 1

  static MODE_SCALE = 2

  constructor( rootView ) { 
    this.rootView = rootView
    this.keyframeSize = 24
    this.mode = TimeCalc.MODE_NONE
  }

  setViewProps( props ) {
    this.scale = props.scale
  }

  xFromEvent( evt ) {
    // let bnd = this.rootView.getBoundingClientRect()
    let x = evt.nativeEvent.offsetX // - bnd.left
    if ( evt.target != this.rootView ) {
      // figure out x in rootView
      let p = evt.target
      while ( p && p != this.rootView ) {
        if ( p.offsetLeft ) {
          x += p.offsetLeft
        }
        p = p.parentNode
      }
    }
    return x
  }

  yFromEvent( evt ) {
    let y = evt.nativeEvent.offsetY - evt.target.offsetY
    if ( evt.target != this.rootView ) {
      // figure out x in rootView
      let p = evt.target
      while ( p && p != this.rootView ) {
        if ( p.offsetHeight ) {
          y += p.offsetHeight
        }
        p = p.parentNode
      }
    }
    return y
  }

  inPopover( evt ) {
    let p = evt.target
    while ( p && p != this.rootView ) {
      if ( p.className && p.className.includes( 'popover' ) ) {
        return true
      }
      p = p.parentNode
    }
    return false
  }

  /**
   * Converts the x position into an x position aligned to the scale and keyframes
   **/
  discreteX( x ) {
    let t = this.xToTime( x )
    if ( this.mode == TimeCalc.MODE_SCALE ) {
      t = Math.round( t / this.scale ) * this.scale
    } else if ( this.mode == TimeCalc.MODE_1000 ) {
      t = Math.round( t / 1000 ) * 1000
    } else {
      t = Math.round( t )
    }
    return this.timeToX( t )
  }

  xToTime( x ) {
    x -= this.keyframeSize / 2 
    // return Math.max( 0, (( x / this.keyframeSize ) * this.scale ) )
    return Math.max( 0, Math.floor( ( x / this.keyframeSize ) * this.scale ) )
  }

  /**
   * Converts the time to the x position
   **/
  timeToX( t ) {
    return this.keyframeSize / 2 + ( this.keyframeSize * t ) / this.scale
  }

  widthAtScale() {
    return this.keyframeSize * Math.ceil( this.maxTime / this.scale )
  }

  // 0->12, 1000->36, 2000->60
}
